import React,{ useEffect, useMemo, useState } from 'react';
import { Accordion, Alert, Badge, Button, ButtonGroup, CloseButton, Col, Container, FloatingLabel, Form, Image, InputGroup, Modal, ModalBody, ProgressBar, Row, Spinner, Tab, Tabs, Toast, ToggleButton } from 'react-bootstrap';
import { AtomicBlockUtils, EditorState, RichUtils, convertFromRaw, convertToRaw } from 'draft-js';
import 'draft-js/dist/Draft.css';
import Editor,{ createEditorStateWithText, composeDecorators } from '@draft-js-plugins/editor';
import createStaticToolbarPlugin from '@draft-js-plugins/static-toolbar';
import '@draft-js-plugins/static-toolbar/lib/plugin.css';
import createInlineToolbarPlugin, { Separator } from '@draft-js-plugins/inline-toolbar';
import '@draft-js-plugins/inline-toolbar/lib/plugin.css';
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
} from '@draft-js-plugins/buttons';
import createLinkPlugin from '@draft-js-plugins/anchor';
import '@draft-js-plugins/anchor/lib/plugin.css';
import createImagePlugin from '@draft-js-plugins/image';
import '@draft-js-plugins/image/lib/plugin.css';
import createVideoPlugin from '@draft-js-plugins/video';
import '@draft-js-plugins/video/lib/plugin.css';
import createTextAlignmentPlugin from '@draft-js-plugins/text-alignment';
import '@draft-js-plugins/text-alignment/lib/plugin.css';

import createAlignmentPlugin from '@draft-js-plugins/alignment';
import createFocusPlugin from '@draft-js-plugins/focus';
import createResizeablePlugin from '@draft-js-plugins/resizeable';
import '@draft-js-plugins/focus/lib/plugin.css';
import '@draft-js-plugins/alignment/lib/plugin.css';

// Initialize plugins
const focusPlugin = createFocusPlugin();
const alignmentPlugin = createAlignmentPlugin();
const resizeablePlugin = createResizeablePlugin();
const { AlignmentTool } = alignmentPlugin;

// Create decorator for image plugin
const decorator = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator,
  focusPlugin.decorator
);

const staticToolbarPlugin = createStaticToolbarPlugin();
const { Toolbar } = staticToolbarPlugin;
const textAlignmentPlugin = createTextAlignmentPlugin();
const imagePlugin = createImagePlugin({ decorator });

function TextReader(props) {
  const [plugins, InlineToolbar, LinkButton] = useMemo(() => {
    const linkPlugin = createLinkPlugin({ placeholder: 'https://...' });
    const videoPlugin = createVideoPlugin();
    const inlineToolbarPlugin = createInlineToolbarPlugin();

    return [
      [
        focusPlugin,
        alignmentPlugin,
        resizeablePlugin,
        imagePlugin,
        textAlignmentPlugin,
        staticToolbarPlugin,
        inlineToolbarPlugin,
        linkPlugin,
        videoPlugin
      ],
      inlineToolbarPlugin.InlineToolbar,
      linkPlugin.LinkButton,
    ];
  }, []);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    if (props.raw === undefined) return;
    const contentState = convertFromRaw(props.raw);
    const editorState = EditorState.createWithContent(contentState);
    setEditorState(editorState);
  }, [props.raw]);

  const onChange = (value) => {
    if (props.onChange === undefined) return;
    setEditorState(value);
    props.onChange(value);
  };

  return (
    <div>
      <div className="reader-content">
        <Editor
          editorState={editorState}
          onChange={onChange}
          plugins={plugins}
          placeholder='本文'
          readOnly
        />
      </div>
      <style jsx>{`
        .reader-content {
          padding: 10px;
          min-height: 100px;
        }
      `}</style>
    </div>
  );
}

export default TextReader;